import { createContext } from 'react'

import type { UseBannerProviderReturn } from './use-banner'

export type BannerContext = Partial<UseBannerProviderReturn>

export const BannerContext = createContext<BannerContext>({})
